export const ROUTE_PATHS = {
  CATEGORY_LIST: "/categories",
  CATEGORY_FORM: "/categories/:categoryId",
  CATEGORY_TREE: "/categories/tree",
  SPECIAL_LIST: "/special-offers",
  SPECIAL_FORM: "/special-offers/:specialId",
  SEO_LIST_CATEGORY: "/categories/seo",
  PRODUCT_LIST: "/products",
  PRODUCT_FORM: "/products/:productId/edit",
  BASIS_PRODUCT_LIST: "/basis-products",
  BASIS_PRODUCT_FORM: "/basis-products/:productId",
  BRAND_LIST: "/brands",
  BRAND_FORM: "/brands/:brandId",
  COLLECTION_LIST: "/collections",
  COLLECTION_FORM: "/collections/:collectionId",
  PRODUCT_TYPE_LIST: "/product-types",
  PRODUCT_TYPE_FORM: "/product-types/:productTypeId",
  PRODUCT_GROUP_LIST: "/product-groups",
  PRODUCT_GROUP_FORM: "/product-groups/:productGroupId",
  FIELD_LIST: "/product-types/:productTypeId/fields",
  FIELD_EDIT_FORM: "/catalog/fields/:fieldId",
  FIELD_CREATE_FORM: "/product-types/:productTypeId/fields/:fieldId",
  TERM_LIST: "/vocabulary",
  TERM_FORM: "/vocabulary/:termId",
  TERM_LINK_LIST: "/vocabulary/:termId/links",
  TERM_LINK_FORM_CREATE: "/vocabulary/:termId/links/:termLinkId",
  TERM_LINK_FORM_UPDATE: "/vocabulary/links/:termLinkId",
};
